import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const AuthForm = ({
  isSignUp,
  email,
  setEmail,
  password,
  setPassword,
  handleAuth,
  toggleAuthMode,
  resetMode,
  setResetMode,
  resetEmail,
  setResetEmail,
  sendPasswordReset,
  error,
  successMessage
}) => {
  const navigate = useNavigate();
  const [validationError, setValidationError] = useState("");

  // ✅ Validate Email Format
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // ✅ Validate Password (Only 8+ Characters, No Restrictions on Character Type)
  const validatePassword = (password) => {
    return password.length >= 8;
  };

  const handleAuthWithValidation = async (e) => {
    e.preventDefault();
    setValidationError("");

    if (!validateEmail(email)) {
      setValidationError("❌ Please enter a valid email address.");
      return;
    }

    if (!validatePassword(password)) {
      setValidationError("❌ Password must be at least 8 characters long.");
      return;
    }

    await handleAuth(e);
    navigate('/welcome');
  };

  return (
    <Form className="mt-4" onSubmit={handleAuthWithValidation} style={{ maxWidth: '400px', margin: 'auto' }}>
      {resetMode === false && (
        <>
          {/* ✅ Login/Signup Form */}
          <Form.Group controlId="formEmail" className="mb-3">
            <Form.Label style={{ fontSize: '16px', color: '#232830', textAlign: 'left', display: 'block' }}>
              Email address
            </Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              isInvalid={!validateEmail(email) && email.length > 0}
              style={{ textAlign: 'left', paddingLeft: '8px' }}
            />
            <Form.Control.Feedback type="invalid">
              ❌ Enter a valid email address (e.g., example@domain.com).
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="formPassword" className="mb-3">
            <Form.Label style={{ fontSize: '16px', color: '#232830', textAlign: 'left', display: 'block' }}>
              Password
            </Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              isInvalid={!validatePassword(password) && password.length > 0}
              style={{ textAlign: 'left', paddingLeft: '8px' }}
            />
            <Form.Control.Feedback type="invalid">
              ❌ Password must be at least 8 characters long.
            </Form.Control.Feedback>
          </Form.Group>

          {/* ✅ Validation & Error Messages */}
          {validationError && <p style={{ fontSize: '14px', color: '#FF4C4C' }}>{validationError}</p>}
          {error && <p style={{ fontSize: '14px', color: '#FF7C24' }}>{error}</p>}
          {successMessage && <p style={{ fontSize: '14px', color: '#28a745' }}>{successMessage}</p>}

          {/* ✅ Submit Button */}
          <Button type="submit" style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24', width: '100%' }}>
            {isSignUp ? 'Sign Up' : 'Login'}
          </Button>

          {/* ✅ Account Toggle Link */}
          <div className="mt-3 text-center">
            <span style={{ fontSize: '14px', color: '#232830' }}>Don't have an account? </span>
            <a href="#" onClick={toggleAuthMode} style={{ color: '#007BFF', fontSize: '14px', fontWeight: 'bold', textDecoration: 'none' }}>
              Login here
            </a>
          </div>
        </>
      )}

      {resetMode && (
        <>
          {/* ✅ Password Reset Form */}
          <Form.Group controlId="resetEmail" className="mb-3">
            <Form.Label style={{ textAlign: 'left', display: 'block' }}>Enter your email to reset password</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter your email"
              value={resetEmail}
              onChange={(e) => setResetEmail(e.target.value)}
              isInvalid={!validateEmail(resetEmail) && resetEmail.length > 0}
              style={{ textAlign: 'left', paddingLeft: '8px' }}
            />
            <Form.Control.Feedback type="invalid">
              ❌ Enter a valid email address.
            </Form.Control.Feedback>
          </Form.Group>

          {/* ✅ Reset Password Button */}
          <Button onClick={sendPasswordReset} style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24', width: '100%' }}>
            Send Reset Email
          </Button>
        </>
      )}

      {/* ✅ Terms & Privacy Links */}
      <div className="mt-3 text-center" style={{ fontSize: '14px', color: '#232830' }}>
        <a href="https://www.fintorro.com/blog/terms-and-conditions" target="_blank" rel="noopener noreferrer" style={{ color: '#007BFF', textDecoration: 'none' }}>
          Terms
        </a>
        {" | "}
        <a href="https://www.fintorro.com/blog/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: '#007BFF', textDecoration: 'none' }}>
          Privacy Policy
        </a>
      </div>

      {/* ✅ Help Link */}
      <div className="mt-3 text-center">
        <a href="https://wa.me/message/4RKX5CK6X7AZG1" target="_blank" rel="noopener noreferrer" style={{ color: '#007BFF', fontSize: '14px', fontWeight: 'bold', textDecoration: 'none' }}>
          Need Help?
        </a>
      </div>
    </Form>
  );
};

export default AuthForm;




// import React, { useState } from 'react';
// import { Form, Button } from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';

// const AuthForm = ({
//   isSignUp,
//   email,
//   setEmail,
//   password,
//   setPassword,
//   handleAuth,
//   toggleAuthMode,
//   resetMode,
//   setResetMode,
//   resetEmail,
//   setResetEmail,
//   sendPasswordReset,
//   error,
//   successMessage
// }) => {
//   const navigate = useNavigate();
//   const [validationError, setValidationError] = useState("");

//   const validateEmail = (email) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

//   const validatePassword = (password) => {
//     const passwordRegex = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/; // At least 1 uppercase, 1 number, min 8 chars
//     return passwordRegex.test(password);
//   };

//   const handleAuthWithValidation = async (e) => {
//     e.preventDefault();
//     setValidationError("");

//     if (!validateEmail(email)) {
//       setValidationError("❌ Please enter a valid email address.");
//       return;
//     }

//     if (!validatePassword(password)) {
//       setValidationError("❌ Password must be at least 8 characters long, include one uppercase letter and one number.");
//       return;
//     }

//     await handleAuth(e);
//     navigate('/welcome');
//   };

//   return (
//     <Form className="mt-4" onSubmit={handleAuthWithValidation} style={{ maxWidth: '400px', margin: 'auto' }}>
//       {resetMode === false && (
//         <>
//           {/* ✅ Login/Signup Form */}
//           <Form.Group controlId="formEmail" className="mb-3">
//             <Form.Label style={{ fontSize: '16px', color: '#232830', textAlign: 'left', display: 'block' }}>
//               Email address
//             </Form.Label>
//             <Form.Control
//               type="email"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               isInvalid={!validateEmail(email) && email.length > 0}
//               style={{ textAlign: 'left', paddingLeft: '8px' }} // ✅ Left aligned text
//             />
//             <Form.Control.Feedback type="invalid">
//               ❌ Enter a valid email address (e.g., example@domain.com).
//             </Form.Control.Feedback>
//           </Form.Group>

//           <Form.Group controlId="formPassword" className="mb-3">
//             <Form.Label style={{ fontSize: '16px', color: '#232830', textAlign: 'left', display: 'block' }}>
//               Password
//             </Form.Label>
//             <Form.Control
//               type="password"
//               placeholder="Enter your password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               isInvalid={!validatePassword(password) && password.length > 0}
//               style={{ textAlign: 'left', paddingLeft: '8px' }} // ✅ Left aligned text
//             />
//             <Form.Control.Feedback type="invalid">
//               ❌ Password must be at least 8 characters, include one uppercase letter and one number.
//             </Form.Control.Feedback>
//           </Form.Group>

//           {/* ✅ Validation & Error Messages */}
//           {validationError && <p style={{ fontSize: '14px', color: '#FF4C4C' }}>{validationError}</p>}
//           {error && <p style={{ fontSize: '14px', color: '#FF7C24' }}>{error}</p>}
//           {successMessage && <p style={{ fontSize: '14px', color: '#28a745' }}>{successMessage}</p>}

//           {/* ✅ Submit Button */}
//           <Button type="submit" style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24', width: '100%' }}>
//             {isSignUp ? 'Sign Up' : 'Login'}
//           </Button>

//           {/* ✅ Account Toggle Link */}
//           <div className="mt-3 text-center">
//             <span style={{ fontSize: '14px', color: '#232830' }}>Don't have an account? </span>
//             <a href="#" onClick={toggleAuthMode} style={{ color: '#007BFF', fontSize: '14px', fontWeight: 'bold', textDecoration: 'none' }}>
//               Sign up here
//             </a>
//           </div>
//         </>
//       )}

//       {resetMode && (
//         <>
//           {/* ✅ Password Reset Form */}
//           <Form.Group controlId="resetEmail" className="mb-3">
//             <Form.Label style={{ textAlign: 'left', display: 'block' }}>Enter your email to reset password</Form.Label>
//             <Form.Control
//               type="email"
//               placeholder="Enter your email"
//               value={resetEmail}
//               onChange={(e) => setResetEmail(e.target.value)}
//               isInvalid={!validateEmail(resetEmail) && resetEmail.length > 0}
//               style={{ textAlign: 'left', paddingLeft: '8px' }} // ✅ Left aligned text
//             />
//             <Form.Control.Feedback type="invalid">
//               ❌ Enter a valid email address.
//             </Form.Control.Feedback>
//           </Form.Group>

//           {/* ✅ Reset Password Button */}
//           <Button onClick={sendPasswordReset} style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24', width: '100%' }}>
//             Send Reset Email
//           </Button>
//         </>
//       )}

//       {/* ✅ Terms & Privacy Links */}
//       <div className="mt-3 text-center" style={{ fontSize: '14px', color: '#232830' }}>
//         <a href="https://www.fintorro.com/blog/terms-and-conditions" target="_blank" rel="noopener noreferrer" style={{ color: '#007BFF', textDecoration: 'none' }}>
//           Terms
//         </a>
//         {" | "}
//         <a href="https://www.fintorro.com/blog/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: '#007BFF', textDecoration: 'none' }}>
//           Privacy Policy
//         </a>
//       </div>

//       {/* ✅ Help Link */}
//       <div className="mt-3 text-center">
//         <a href="https://wa.me/message/4RKX5CK6X7AZG1" target="_blank" rel="noopener noreferrer" style={{ color: '#007BFF', fontSize: '14px', fontWeight: 'bold', textDecoration: 'none' }}>
//           Need Help?
//         </a>
//       </div>
//     </Form>
//   );
// };

// export default AuthForm;







// import React from 'react';
// import { Form, Button } from 'react-bootstrap';

// const AuthForm = ({
//   isSignUp,
//   email,
//   setEmail,
//   password,
//   setPassword,
//   handleAuth,
//   toggleAuthMode,
//   resetMode,
//   setResetMode,
//   resetEmail,
//   setResetEmail,
//   sendPasswordReset,
//   error,
//   successMessage
// }) => {
//   return (
//     <Form className="mt-4">
//       {resetMode === false && (
//         <>
//           {/* Login/Signup Form */}
//           <Form.Group controlId="formEmail" className="mb-3">
//             <Form.Label style={{ fontSize: '16px', color: '#232830' }}>Email address</Form.Label>
//             <Form.Control
//               type="email"
//               placeholder="Enter your email"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//             />
//           </Form.Group>

//           <Form.Group controlId="formPassword" className="mb-3">
//             <Form.Label style={{ fontSize: '16px', color: '#232830' }}>Password</Form.Label>
//             <Form.Control
//               type="password"
//               placeholder="Enter your password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//             />
//           </Form.Group>

//           <div className="mt-2">
//             {/* <a href="#" onClick={() => setResetMode(true)} style={{ color: '#FF7C24', fontSize: '14px' }}>
//               Forgot Password?
//             </a> */}
//           </div>

//           {error && <p style={{ fontSize: '14px', color: '#FF7C24' }}>{error}</p>}
//           {successMessage && <p style={{ fontSize: '14px', color: '#28a745' }}>{successMessage}</p>}

//           <Button onClick={handleAuth} style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24' }}>
//             {isSignUp ? 'Sign Up' : 'Login'}
//           </Button>

//           <div className="mt-3">
//             <a href="#" onClick={toggleAuthMode} style={{ color: '#FF7C24', fontSize: '14px' }}>
//               {isSignUp ? 'Already have an account? Sign in' : "Don't have an account? Sign up"}
//             </a>
//           </div>
//         </>
//       )}

//       {resetMode && (
//         <>
//           {/* Password Reset Form */}
//           <Form.Group controlId="resetEmail" className="mb-3">
//             <Form.Label>Enter your email to reset password</Form.Label>
//             <Form.Control
//               type="email"
//               placeholder="Enter your email"
//               value={resetEmail}
//               onChange={(e) => setResetEmail(e.target.value)}
//             />
//           </Form.Group>

//           {error && <p style={{ fontSize: '14px', color: '#FF7C24' }}>{error}</p>}
//           {successMessage && <p style={{ fontSize: '14px', color: '#28a745' }}>{successMessage}</p>}

//           <Button onClick={sendPasswordReset} style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24' }}>
//             Send Reset Email
//           </Button>
//         </>
//       )}
//     </Form>
//   );
// };

// export default AuthForm;
